/* ORIO custom illustrations — generated via Gemini Nano Banana, served by backend /static
 * Falls back to a unified Unsplash fallback if the asset isn't generated yet. */

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Map of slug -> { local, fallback }
const ASSETS = {
  // weather moods
  "weather-hot":   "https://images.unsplash.com/photo-1749324180583-a089a6d1c0da?w=600&h=600&fit=crop",
  "weather-cold":  "https://images.unsplash.com/photo-1640600828499-d24e48f168b9?w=600&h=600&fit=crop",
  "weather-snow":  "https://images.unsplash.com/photo-1701187259642-8b843e4fde3f?w=600&h=600&fit=crop",
  "weather-rain":  "https://images.unsplash.com/photo-1597602570981-dfe78b32c8ff?w=600&h=600&fit=crop",
  "weather-wind":  "https://images.unsplash.com/photo-1742301874088-43e5882d94d4?w=600&h=600&fit=crop",
  "weather-mild":  "https://images.unsplash.com/photo-1690717967107-ddbe5781019a?w=600&h=600&fit=crop",
  // feature carousel
  "feat-create-dog": "https://images.unsplash.com/photo-1544146739-a08d030ccf24?w=600&h=600&fit=crop",
  "feat-microchip":  "https://images.unsplash.com/photo-1623103714215-5c60d8b5e512?w=600&h=600&fit=crop",
  "feat-walk":       "https://images.unsplash.com/photo-1742301874088-43e5882d94d4?w=600&h=600&fit=crop",
  "feat-match":      "https://images.unsplash.com/photo-1760530327971-f8523426c60a?w=600&h=600&fit=crop",
  "feat-drawer":     "https://images.unsplash.com/photo-1690717967107-ddbe5781019a?w=600&h=600&fit=crop",
  "feat-missions":   "https://images.unsplash.com/photo-1564396852172-e7b1a7cf9ed5?w=600&h=600&fit=crop",
  "feat-vet":        "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=600&h=600&fit=crop",
  "feat-parks":      "https://images.unsplash.com/photo-1601758174039-cda7c4ec3e7a?w=600&h=600&fit=crop",
  "feat-sos":        "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&h=600&fit=crop",
  // tips
  "tip-sos":         "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&h=600&fit=crop",
  "tip-vet":         "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=600&h=600&fit=crop",
  "tip-microchip":   "https://images.unsplash.com/photo-1623103714215-5c60d8b5e512?w=600&h=600&fit=crop",
  "tip-match":       "https://images.unsplash.com/photo-1760530327971-f8523426c60a?w=600&h=600&fit=crop",
  "tip-cassetto":    "https://images.unsplash.com/photo-1690717967107-ddbe5781019a?w=600&h=600&fit=crop",
  "tip-karma":       "https://images.unsplash.com/photo-1564396852172-e7b1a7cf9ed5?w=600&h=600&fit=crop",
  "tip-walking":     "https://images.unsplash.com/photo-1742301874088-43e5882d94d4?w=600&h=600&fit=crop",
  "tip-hazard":      "https://images.unsplash.com/photo-1601758174039-cda7c4ec3e7a?w=600&h=600&fit=crop",
  "tip-shelter":     "https://images.unsplash.com/photo-1564396852172-e7b1a7cf9ed5?w=600&h=600&fit=crop",
  "tip-meteo":       "https://images.unsplash.com/photo-1749324180583-a089a6d1c0da?w=600&h=600&fit=crop",
  "tip-qr":          "https://images.unsplash.com/photo-1623103714215-5c60d8b5e512?w=600&h=600&fit=crop",
  "tip-pro":         "https://images.unsplash.com/photo-1690717967107-ddbe5781019a?w=600&h=600&fit=crop",
  // pro banner
  "pro-banner":      "https://images.unsplash.com/photo-1635416651032-191ab4bf66a1?w=600&h=600&fit=crop",
  // Match Hub (v16 — 3 modes)
  "match-walking":   "https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8?w=600&h=600&fit=crop",
  "match-park":      "https://images.unsplash.com/photo-1601758174039-cda7c4ec3e7a?w=600&h=600&fit=crop",
  "match-educator":  "https://images.unsplash.com/photo-1587764379873-97837921fd44?w=600&h=600&fit=crop",
  // v20 — fresh ORIO illustrations (painterly humans + photoreal dogs).
  "match-walking-v2":   "https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8?w=600&h=600&fit=crop",
  "match-park-v2":      "https://images.unsplash.com/photo-1601758174039-cda7c4ec3e7a?w=600&h=600&fit=crop",
  "match-educator-v2":  "https://images.unsplash.com/photo-1587764379873-97837921fd44?w=600&h=600&fit=crop",
  "tip-community-v2":   "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&h=600&fit=crop",
  "tip-karma-v2":       "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&h=600&fit=crop",
  "tip-safewalk-v2":    "https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8?w=600&h=600&fit=crop",
  "tip-emergenza-v2":   "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=600&h=600&fit=crop",
  "tip-veterinario-v2": "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=600&h=600&fit=crop",
  "tip-passaporto-v2":  "https://images.unsplash.com/photo-1623103714215-5c60d8b5e512?w=600&h=600&fit=crop",
  "feat-community-v2":  "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&h=600&fit=crop",
  "feat-rifugio-v2":    "https://images.unsplash.com/photo-1564396852172-e7b1a7cf9ed5?w=600&h=600&fit=crop",
  "feat-karma-v2":      "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=600&h=600&fit=crop",
  // Landing hero for Match+Stories section — generated via Nano Banana v23 style.
  "landing-match-stories": "https://images.unsplash.com/photo-1601758125946-6ec2ef64daf8?w=800&h=500&fit=crop",
  // Welcome hero for /login screen — first-launch impression from Play Store
  "welcome-hero": "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=1080&h=1440&fit=crop",
};

/** Return URL for a given ORIO illustration slug.
 *  Uses the storage-first proxy `/api/illustrations/{slug}.png` which:
 *    1. tries Emergent Object Storage (v27 cinema-realistic batch lives here)
 *    2. falls back to the repo-committed local static file (older shipped assets)
 *  The `?v=` cache-buster is bumped whenever we regenerate the batch. */
const IMG_VERSION = "v27";
export function orioIllustration(slug) {
  // The component using this should pass loading="lazy" + onError that swaps to fallback().
  return `${BACKEND}/api/illustrations/${slug}.png?v=${IMG_VERSION}`;
}

export function orioIllustrationFallback(slug) {
  return ASSETS[slug] || ASSETS["feat-walk"];
}
